import { AppleLogo } from '@jouzen/ecom-components/icons/AppleLogo';
import { GoogleHealthConnectLogo } from '@jouzen/ecom-components/icons/GoogleHealthConnectLogo';
import { useTranslations } from 'next-intl';
import type { SVGIconComponent } from 'types/svgr';

import LandingPageIntegrations from '@/app/components/LandingPage/LandingPageIntegrations';

const HeartHealthIntegrations = () => {
  const t = useTranslations();
  return (
    <section
      className="py-16 text-brown-600"
      data-cy="heart-health-integrations"
    >
      <LandingPageIntegrations
        description="heart_health_integrations_description"
        logoColor="black"
        integrations={[
          {
            description: 'heart_health_integrations_apple',
            Logo: AppleLogo as SVGIconComponent,
            name: t('integrations_apple_health_kit'),
          },
          {
            description: 'heart_health_integrations_google',
            Logo: GoogleHealthConnectLogo as SVGIconComponent,
            name: t('integrations_google_health_connect'),
          },
        ]}
        title="pop_integrations_title"
      />
    </section>
  );
};

export default HeartHealthIntegrations;
